import { Component } from '@angular/core';
import { CaseFormSectionContainerComponent } from 'app/shared/components/forms/case-form-section-container/case-form-section-container.component';
import { ConfigureInformationSidebarComponent } from './configure-information-sidebar/configure-information-sidebar.component';
import { CommonModule } from '@angular/common';
import { ConfigureInformationDatatableComponent } from './configure-information-datatable/configure-information-datatable.component';
import { TabsWithContentComponent } from 'app/shared/components/tabs-with-content/tabs-with-content.component';
import { Tab } from 'app/shared/enums/profile.enum';
import { DiscardChangesService } from 'app/shared/services/discard-changes.service';

@Component({
  selector: 'app-configure-information',
  standalone: true,
  imports: [
    CommonModule,
    CaseFormSectionContainerComponent,
    ConfigureInformationSidebarComponent,
    ConfigureInformationDatatableComponent,
    TabsWithContentComponent
  ],
  templateUrl: './configure-information.component.html',
  styleUrl: './configure-information.component.scss'
})
export class ConfigureInformationComponent {
  public Tab = Tab;
  sidebarItemData: any = {};
  tabs = [Tab.SimpleDropdowns, Tab.ComplexDropdowns];
  selectedTab = Tab.SimpleDropdowns;

  constructor(private discardChangesService: DiscardChangesService) {}

  onSidebarItemData(item: any) {
    this.sidebarItemData = item;
  }

  navigateToTab(tab: string): void {
    this.discardChangesService.canDeactivate().then(
      (result) => {
        if(result) {
          this.selectedTab = tab as Tab;
        }
      }
    );
  }

}
